module.exports = __webpack_public_path__ + "static/media/brand2-small.0d09a2c1.jpg";